import { useTranslation } from "react-i18next";
import { useState, useCallback } from 'react';

import PageWrapper from "components/page/PageWrapper";
import TabBar from "components/tabbar/TabBar";
import Company from "components/company/Company";

import bg from 'assets/images/banner/banner02.jpg';

import ProductTi from "./ProductTi";
import ProductSo from "./ProductSo";

export default function Optimizers(){
  const {t} = useTranslation();
  const menuName= t('menu.sub-optimizers');
  const path=[
    {url:'/solutions', name:t('menu.main-solutions')},
    {url:'/solutions/optimizers', name:menuName}];
  const title = t('optimizers.banner.title')
  const comment = t('optimizers.banner.comment')

  const tabs = [
    t('optimizers.tabs.name-1'),
    t('optimizers.tabs.name-2')
  ];
  const prefix = ['ti', 'so'];
  const width = [108, 108];
  const imgs = ['company.png', 'company.png']
  const [index, setIndex] = useState(0);
  const handleClick = useCallback((index)=>{
    setIndex(index);
  }, [setIndex]);

  const products = [
    <ProductTi/>,
    <ProductSo/>
  ]

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className='flex flex-col w-full lg:items-center'>
        <TabBar tabs={tabs} callback={handleClick} selected={index} className='px-mobile lg:px-0'/>
        {index===0? 
          <Company module="optimizers" prefix={prefix[index]} className='px-mobile lg:px-0'
            index={index} ciWidth={width[index]} img={imgs[index]}/>
        : null}
        {products[index]}
      </div>
    </PageWrapper>
  );
}